module.exports = __webpack_public_path__ + "img/sb10.a7bcdc97.png";